export default "__VITE_ASSET__BxPwI0Jl__"